import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "9", y1: "4", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 7c0-1.7 1.3-3 3-3h13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 20c-1.7 0-3-1.3-3-3V4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Pi";
const Pi = memo(themed(Icon));
export {
  Pi
};
//# sourceMappingURL=pi.js.map
